import React from "react";
import css from "./index.module.scss";
import GenericLayout from "layouts/generic";
import LogoAnimatedSvg from "/public/images/logos/deviatelabs/animatedSeal.svg";
import RevealedText from "@/components/revealedText";
import FloatingImage from "@/components/floatingImage";
import BobbingArrow from "@/components/bobbingArrow";
import VideoOptin from "@/sections/videoOptin";
import Button from "@/components/button";



export default function AgencyOverviewPresentationPage() {
  return (
    <GenericLayout
      title="&#x1F4C8; Innovative Growth Marketing Agency (Trusted)"
      description="We are a cutting-edge growth marketing agency helping our clients achieve unprecedented results through growth hack marketing."
      schema={ {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Deviate Labs",
        "legalName": "Deviate Labs Llc",
        "url": "https://deviatelabs.com",
        "logo": "https://deviatelabs.com//images/logos//logo.svg",
        "foundingDate": "2014",
        "founders": [
          {
            "@type": "Person",
            "name": "Chad Riddersen",
          }, {
            "@type": "Person",
            "name": "Raymond Fong",
          },
        ],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "8605 Santa Monica Blvd, Ste 93568",
          "addressLocality": "Los Angeles",
          "addressRegion": "CA",
          "postalCode": "90069",
          "addressCountry": "USA",
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer support",
          "telephone": "[+888-733-8609]",
          "email": "hello@deviatelabs.com",
        },
        "sameAs": ["https://www.facebook.com/deviatelabs", "https://www.linkedin.com/company/deviatelabs"],
      }}
      canonical="/agency-overview-presentation/"
      customMetaTags={[{ name: "robots", content: "noindex" }]}
    >

      <section className={`section ${css.fold}`}>
        <div className={`sectionInner ${css.sectionInner}`}>
          <h1>
            <div><span>Deviate Labs</span></div>
            <div><span>Agency Overview</span></div>
            <div className={`subttile ${css.subtitle}`}>Learn how Deviate Labs can help you reach your growth goals.</div>
          </h1>
          <BobbingArrow href="#question"/>
        </div>

        <div className={css.svgWrapper}>
          <LogoAnimatedSvg/>
        </div>
      </section>

      <VideoOptin wistiaUrl="https://deviatelabs.wistia.com/medias/ohjcqdc2l8" imageBase="/images/videos/optin/vidthumb"/>


    </GenericLayout>
  );
}
